// At the map's closest zoom an 18px pin covers about 5 m, so pins nearer than this can't be told
// apart or clicked separately however far you zoom in.
export const SAME_LOCATION_METERS = 5;

const METERS_PER_DEGREE = 111320;

function metersBetween(a, b) {
    const north = (a.latitude - b.latitude) * METERS_PER_DEGREE;
    const east = (a.longitude - b.longitude) * METERS_PER_DEGREE * Math.cos(a.latitude * Math.PI / 180);
    return Math.sqrt(north * north + east * east);
}

export function groupByLocation(items) {
    let groups = [];

    items.forEach(item => {
        const isNear = group => group.some(other => metersBetween(item, other) <= SAME_LOCATION_METERS);
        const near = groups.filter(isNear);
        groups = [...groups.filter(group => !isNear(group)), [].concat(...near, [item])];
    });

    return groups;
}
